export const MAX_FILE_SIZE = 15;
export const MAX_TOTAL_FILES_SIZE = 15;
export const MAX_NUMBERS_OF_FILES = 1;
export const COLUMN_GRID_COUNT = 12;
export const ALLOWED_MIME_TYPES = [
    'application/pdf',
    'application/rtf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const CAREER_SITE_ID = 16302;

export const ENGLISH_LEVEL_OPTIONS = [
    {
        id: '',
        label: '',
    },
    {
        id: 'Intermediate',
        label: 'Intermediate',
    },
    {
        id: 'Upper-Intermediate',
        label: 'Upper-Intermediate',
    },
    {
        id: 'Advanced Proficiency',
        label: 'Advanced Proficiency',
    },
];

export const COUNTRIES_OPTIONS = [
    {
        id: '',
        label: '',
    },
    {
        id: 'Lithuania',
        label: 'Lithuania',
    },
    {
        id: 'Bulgaria',
        label: 'Bulgaria',
    },
    {
        id: 'Poland',
        label: 'Poland',
    },
    {
        id: 'Belarus',
        label: 'Belarus',
    },
    {
        id: 'Ukraine',
        label: 'Ukraine',
    },
    {
        id: 'Georgia',
        label: 'Georgia',
    },
    {
        id: 'Other',
        label: 'Other',
    },
];

export const PREFERRED_CAREER_COUNTRIES = [
    {
        code: 'ph',
        name: 'Philippines',
    },
    {
        code: 'lt',
        name: 'Lithuania',
    },
    {
        code: 'lv',
        name: 'Latvia',
    },
    {
        code: 'ee',
        name: 'Estonia',
    },
    {
        code: 'bg',
        name: 'Bulgaria',
    },
    {
        code: 'ro',
        name: 'Romania',
    },
    {
        code: 'pl',
        name: 'Poland',
    },
    {
        code: 'dz',
        name: 'Algeria',
    },
    {
        code: 'ma',
        name: 'Morocco',
    },
    {
        code: 'mg',
        name: 'Madagascar',
    },
    {
        code: 'al',
        name: 'Albania',
    },
    {
        code: 'xk',
        name: 'Kosovo',
    },
    {
        code: 'ua',
        name: 'Ukraine',
    },
    {
        code: 'ge',
        name: 'Georgia',
    },
    {
        code: 'in (ahmedabad)',
        name: 'India (Ahmedabad)',
    },
    {
        code: 'international',
        name: 'International',
    },
    {
        code: 'other',
        name: 'Other',
    },
];

export const LOCATIONS_CODES_TO_ID_MAPPING = [
    { id: 738, code: 'LT' },
    { id: 739, code: 'BG' },
    { id: 740, code: 'UA' },
    { id: 741, code: 'PL' },
    { id: 742, code: 'BY' },
    { id: 743, code: 'EE' },
    { id: 744, code: 'GE' },
    { id: 745, code: 'MG' },
    { id: 746, code: 'MA' },
    { id: 747, code: 'PH' },
    { id: 748, code: 'LV' },
    { id: 749, code: 'RO' },
    { id: 750, code: 'Other' },
];

export const DEFAULT_COUNTRY_CODE = 'lt';
export const INTERNATIONAL_COUNTRY_CODE = 'international';
export const OTHER_COUNTRY_CODE = 'other';
export const COUNTRY_DROPDOWN_ID = 'country-select';
export const PREFERRED_CAREER_COUNTRY_KEY = 'preferred_career_country';
export const VACANCY_CUSTOM_FIELD_NAMES = {
    countries: 'countries',
};

export const DEPARTMENT_DROPDOWN_ID = 'department-select';
export const DEFAULT_DEPARTMENT = 'all';
export const ALL_DEPARTMENTS_TEXT = 'All Departments';
